const dev = {
    endpoints: {
        itarXferAdminAuthn: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferAdminAuthn",
        itarXferAdminAuthz: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferAdminAuthz",
        itarXferCreateSecret: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCreateSecret",
        itarXferAuthzSecret: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferAuthzSecret",
        itarXferSinglePartUpload: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferSinglePartUpload",
        itarXferStartMultipartUpload: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferStartMultipartUpload",
        itarXferGetUploadPartUrl: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferGetUploadPartUrl",
        itarXferCompleteMultipartUpload: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCompleteMultipartUpload",
        itarXferCreateTinyUrlCode: 'https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCreateTinyUrlCode',
        itarXferLookupTinyUrlCode: 'https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferLookupTinyUrlCode',
    },
    downloadBaseUrl: 'http://localhost:3000/download'
};

const prd = {
    endpoints: {
        itarXferAdminAuthn: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferAdminAuthn",
        itarXferAdminAuthz: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferAdminAuthz",
        itarXferCreateSecret: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCreateSecret",
        itarXferAuthzSecret: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferAuthzSecret",
        itarXferSinglePartUpload: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferSinglePartUpload",
        itarXferStartMultipartUpload: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferStartMultipartUpload",
        itarXferGetUploadPartUrl: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferGetUploadPartUrl",
        itarXferCompleteMultipartUpload: "https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCompleteMultipartUpload",
        itarXferCreateTinyUrlCode: 'https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferCreateTinyUrlCode',
        itarXferLookupTinyUrlCode: 'https://rl3ws2zz7g.execute-api.us-gov-west-1.amazonaws.com/prd/itarXferLookupTinyUrlCode',
    },
    downloadBaseUrl: 'https://itar.sc.ascendingnode.tech/download'
};

const configMap = {
    'prd': prd,
    'dev': dev,
};

const config = configMap[process.env.REACT_APP_STAGE];

export const endpoints = config.endpoints;
export const downloadBaseUrl = config.downloadBaseUrl;
